export default function PageDivider({ blok }) {
  return (
    <section className="px-8">
      <h2 className="text-center uppercase text-m2 my-12 relative mx-auto before:content-[''] before:h-[3px] before:w-full before:bg-blue before:absolute before:z-0 before:left-0 before:top-1/2 before:-translate-y-1/2 before:px-8 max-w-full min-w-full block">
        <span className="font-primary bg-white block w-auto sm:w-max mx-auto sm:border-x-8 relative z-10 border-white max-w-[190px] sm:max-w-3xl">
          {blok?.title ? blok.title : null}
        </span>
      </h2>
    </section>
  )
}
